module.exports = __webpack_public_path__ + "img/314ceb2.webp";